import { type TableParamsType } from '../../types/common';
import { type UseQueryResult, useQuery } from 'react-query';
import {
  TradePreClearanceApprovalService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_TradePreClearanceRequestListDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetPreClearanceRequestList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_TradePreClearanceRequestListDto | undefined,
  unknown
> => {
  const { approvalStatusId, awardTypeId, filter, sorting, skipCount, maxResultCount, _force } =
    tableInfo;
  const preClearanceRequestList = useQuery(
    [
      'getPreClearanceRequestList',
      approvalStatusId,
      awardTypeId,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        TradePreClearanceApprovalService.getApiAwardApiAppTradePreClearanceApprovalPreClearanceRequestList(
          approvalStatusId,
          awardTypeId,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return preClearanceRequestList;
};

export default useGetPreClearanceRequestList;
